var generateStyle = function generateStyle(componentTheme) {
  return {
    middleSection: {
      flexGrow: '2'
    },
    endSection: {
      flexGrow: '1',
      textAlign: 'right'
    },
    questionCount: {
      flexGrow: '1'
    },
    itemsContainer: {
      color: componentTheme.itemContainerColor,
      display: 'flex',
      width: '100%',
      padding: componentTheme.itemContainerPadding,
      border: "dotted ".concat(componentTheme.itemContainerBorderWidth),
      borderColor: componentTheme.itemContainerBorderColor
    },
    summary: {
      margin: componentTheme.summaryMargin,
      marginLeft: componentTheme.summaryMarginLeft,
      display: 'flex',
      flexGrow: '1'
    }
  };
};
export default generateStyle;